import React, { useState } from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { PlusIcon, XIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-[#CCCCCC] py-4" data-id="element-1994">
      <button className="w-full flex items-center justify-between text-left py-2 focus:outline-none group min-h-[48px]" onClick={onClick} data-id="element-1995">
        <span className="text-black font-bold text-lg font-[Poppins,_sans-serif] pr-8 group-hover:text-[#FF1493] transition-colors" data-id="element-1996">
          {question}
        </span>
        <span className="text-[#FF1493] flex-shrink-0 transition-transform duration-300" data-id="element-1997">
          {isOpen ? <XIcon size={24} data-id="element-1998" /> : <PlusIcon size={24} data-id="element-1999" />}
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-2000">
        <p className="text-[#333333] text-base font-body leading-[1.7] pt-4 pb-2" data-id="element-2001">
          {answer}
        </p>
      </div>
    </div>;
}
export function STFAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const faqs = [{
    question: 'What Is The Treatment Like?',
    answer: 'During a SkinTyte treatment, patients typically experience a warm sensation as rapid bursts of light penetrate the skin. The procedure is quick and virtually painless, with sessions lasting about 30-45 minutes depending on the treated area. Patients can relax during the treatment and resume their daily activities immediately afterward.'
  }, {
    question: 'How Many Sessions Are Needed?',
    answer: 'SkinTyte is typically performed as part of a series, spaced approximately 2-6 weeks apart, depending on the depth and coverage area of the treatment, as well as the health and integrity of the skin being treated.'
  }, {
    question: 'Is There Downtime After A Treatment?',
    answer: 'Following a SkinTyte session, most patients can return to their regular activities right away. Some may experience temporary redness or swelling, which usually resolves within a few hours. Dark spots may initially darken before flaking off in the coming weeks, with noticeable improvement visible after just one treatment and full results after completing the recommended series.'
  }, {
    question: 'How Long Do Results Last?',
    answer: 'While individual results vary, most patients notice improved skin starting 4-6 weeks after the first treatment.'
  }];
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-2002">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-2003">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-2004">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-2005">
            FREQUENTLY ASKED QUESTIONS
          </h2>
          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-2006"></div>
        </AnimateOnScroll>

        <AnimateOnScroll delay={200} data-id="element-2007">
          <div className="space-y-2" data-id="element-2008">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? -1 : index)} data-id="element-2009" />)}
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}